import { isAxiosError } from 'axios'

interface RolloverErrorResponse {
  error?: { code?: string; details?: { computed_usage?: unknown } }
}

/** The API computes the usage to review; never infer it from an error message. */
export function rolloverUsageFromError(error: unknown): number | null {
  if (!isAxiosError<RolloverErrorResponse>(error) || error.response?.status !== 422) return null
  const details = error.response.data.error
  const usage = details?.details?.computed_usage
  return details?.code === 'rollover_needs_confirmation' &&
    typeof usage === 'number' && Number.isFinite(usage) && usage >= 0 ? usage : null
}
